import React, { useState, useEffect } from "react";
import Loader from "./Loader";
import { fetchPickUpTransactionByCode } from "../apis/transaction";
import { displayToast } from "../utils/Toast";
import { formatDate } from "../utils/Formatter";
import { useErrorHandler } from "../services/ErrorHandler";
import { useSalesFormStore } from "../services/useSalesFormStore";
import "../styles/components/TransactionTable.css";

const SelectTransactionTable = ({
  pickUpItemHeadings = [],
  selectedMainTableRow,
  setLocalSelectedItems,
}) => {
  const [loading, setLoading] = useState(false);
  const { handleErrorResponse } = useErrorHandler();
  const [filterdData, setFilterdData] = useState([]);
  const [transactionTableData, setTransactionTableData] = useState([]);
  const { selectedPickUpTransactionItems } = useSalesFormStore();

  const fetchTransactionTableData = async () => {
    try {
      setLoading(true);
      let type = `item_data/${selectedMainTableRow?.tran_code}?tran_id=${selectedMainTableRow?.tran_id}`;
      const transactionDataResponse = await fetchPickUpTransactionByCode(type);
      if (transactionDataResponse.description) {
        setLoading(false);
        handleErrorResponse(transactionDataResponse.description);
        displayToast(transactionDataResponse.description, "error");
      } else {
        setTransactionTableData(transactionDataResponse.items);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactionTableData();
  }, [selectedMainTableRow]);

  const handleCheckboxChange = (index) => {
    const updatedData = [...filterdData];
    updatedData[index].selected = !updatedData[index].selected;
    setFilterdData(updatedData);
    const selectedData = updatedData.filter((item) => item.selected === true);
    setLocalSelectedItems(selectedData);
  };

  useEffect(() => {
    const selectedIds = selectedPickUpTransactionItems.map((item) => item.id);
    const updatedData = transactionTableData.map((item) =>
      selectedIds.includes(item.id) ? { ...item, selected: true } : item
    );

    setFilterdData(updatedData);
  }, [transactionTableData]);

  useEffect(() => {
    if (selectedMainTableRow) {
      setFilterdData((prevData) =>
        prevData.map((item) => ({ ...item, selected: false }))
      );
    }
  }, [selectedMainTableRow]);

  return (
    <div className="transaction-card">
      <div className="pickup-transaction-card-content">
        {loading ? (
          <Loader />
        ) : (
          <div className="pickup-item-transaction-table-container">
            <table className="pickup-item-transaction-table">
              <thead>
                <tr>
                  {pickUpItemHeadings?.map((heading, index) => (
                    <th key={index} className="col-item-name">
                      {heading.display_name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filterdData.length === 0 ? (
                  <tr>
                    <td className="text-center">
                      Transaction items are not available.
                    </td>
                  </tr>
                ) : (
                  filterdData.map((row, index) => (
                    <tr
                      key={index}
                      className={row.selected ? "selected-row" : ""}
                      onClick={() => handleCheckboxChange(index)}
                    >
                      <td>
                        <input type="checkbox" checked={row.selected} />
                        {row.product_name}
                      </td>
                      {pickUpItemHeadings.map((heading, colIndex) => {
                        const cellData = row[heading.field_name];
                        const formattedCellData = [
                          "created_at",
                          "updated_at",
                          "date",
                        ].includes(heading.field_name)
                          ? formatDate(cellData)
                          : cellData;
                        return (
                          heading.field_name !== "product_name" && (
                            <td key={colIndex}>{formattedCellData || "N/A"}</td>
                          )
                        );
                      })}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectTransactionTable;
